export default __webpack_public_path__ + "static/fabric-plugin-a2ad561d5ffdf033f8b3d81dfe11f86f.png";